<div id="todo" class="page-layout carded left-sidebar inner-scroll">
    <!-- SIDEBAR -->
    <fuse-sidebar class="sidebar" name="customer-details-sidebar" position="left" lockedOpen="gt-md">
        <customer-details-sidebar [user]="user"></customer-details-sidebar>
    </fuse-sidebar>
    <!-- / SIDEBAR -->

    <!-- CONTENT -->
    <div class="page-layout blank p-24 ps">
        <table class="simple invoice-table">
            <tbody>
                <tr>
                    <td class="text-left">
                        <div class="title">
                            {{'First name'|translate}}
                        </div>
                    </td>
                    <td class="text-left">{{user.firstName}}</td>
                </tr>
                <tr>
                    <td class="text-left">
                        <div class="title">
                            {{'Last name'|translate}}
                        </div>
                    </td>
                    <td class="text-left">{{user.lastName}}</td>
                </tr>
                <tr>
                    <td class="text-left">
                        <div class="title">
                            {{'Sex'|translate}}
                        </div>
                    </td>
                    <td class="text-left">{{user.sex|translate}}</td>
                </tr>
                <tr>
                    <td class="text-left">
                        <div class="title">
                            {{'E-mail'|translate}}
                        </div>
                    </td>
                    <td class="text-left">{{user.email}}</td>
                </tr>
                <tr>
                    <td class="text-left">
                        <div class="title">
                            {{'Phone'|translate}}
                        </div>
                    </td>
                    <td class="text-left">{{user.phone}}</td>
                </tr>
                <tr>
                    <td class="text-left">
                        <div class="title">
                            {{'Birthday'|translate}}
                        </div>
                    </td>
                    <td class="text-left">{{user.birthday}}</td>
                </tr>
                <tr>
                    <td class="text-left">
                        <div class="title">
                            {{'Customer description'|translate}}
                        </div>
                    </td>
                    <td class="text-left">
                        <a (click)="showCustomerContactDetails(user)" style="cursor: pointer;">
                            {{user.description}}
                        </a>
                    </td>
                </tr>
            </tbody>
            <tfoot>
            <tr>
                <td colspan="2" style="text-align: right;">
                    <a appDisableRightClick
                       *appIsGranted="['Customers', 'UPDATE']"
                       routerLink="/customers/edit/{{user.id}}"
                       mat-button
                       color="primary"
                    >
                        {{'Edit'|translate}}
                    </a>
                </td>
            </tr>
            </tfoot>
        </table>
    </div>
</div>
